import {DashboardPanelData} from '../../../interfaces/Dashboard';
import {EventTotalKpi} from '../HazardAIEventTotal/EventTotalKpi';

interface Props {
  value?: DashboardPanelData;
  onUpdate?: (value?: DashboardPanelData) => void;
}

export const HazardAITotalDetections = (props?: Props) => (
  <EventTotalKpi
    {...props}
    label="Total Detections"
    errorId="STRA_f4a2b8c1"
  />
);
